import { useContext } from "react";
import { api } from "../../../api";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { OverflowFrame } from "../../../externalComponents";
import { Button } from "../../../externalComponents/tailwind/button";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { CustomerContext } from "../../../providers";
import { openSignInWindow } from "../../../360dialog-connect-button/src/open-popup";
import { WhatsappQualityScoreBanner } from "../../../externalComponents/WhatsappQualityScoreBanner";

export default function WhatsappConnexionPage() {
  const { customer } = useContext(CustomerContext);

  const url360 =
    "https://hub.360dialog.com/dashboard/app/ZoMqCNPA/permissions?plan_selection=basic";

  // Facebook Login with JavaScript SDK
  function launchWhatsAppSignup() {
    // Launch Facebook login
    FB.login(
      (response) => {
        console.log(response);
        if (response.authResponse) {
          const accessToken = response.authResponse.code;
          //Use this token to call the debug_token API and get the shared WABA's ID
          console.log(accessToken);
          const result = api.finishEmbeddedSignup({
            accessToken,
            customerId: customer.id,
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: "993629832266228", // configuration ID obtained in the previous step goes here
        response_type: "code", // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
          setup: {
            phone: {
              displayName: customer?.name,
              category: "RETAIL",
            },
          },
        },
      },
    );
  }

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Connexion" />
        <OverflowFrame>
          <div className="my-5">
            {(customer?.apiKey360Dialog || customer?.waAccessToken) && (
              <>
                <Heading className="text-lg mb-5">
                  Your WhatsApp account is connected 🎉
                </Heading>

                <Button
                  color="secondaryButton"
                  onClick={() =>
                    window.open(
                      "https://business.facebook.com/wa/manage/phone-numbers/",
                      "_blank",
                    )
                  }
                >
                  Edit WhatsApp profile
                </Button>

                <br />
                <br />
              </>
            )}
            {!customer?.apiKey360Dialog &&
              !customer?.waAccessToken &&
              customer?.isSubscribed && (
                <>
                  <Heading className="text-lg mb-5">
                    Start by creating you account
                  </Heading>
                  <Button
                    color="secondaryButton"
                    onClick={() =>
                      openSignInWindow(
                        url360,
                        "connect-360dialog",
                        window.location.origin,
                      )
                    }
                  >
                    Create a WhatsApp account with 360dialog
                  </Button>
                  <br />
                  <br />
                  or
                  <br />
                  <br />
                  <button
                    onClick={launchWhatsAppSignup}
                    style={{
                      backgroundColor: "#1877f2",
                      border: "0",
                      borderRadius: "4px",
                      color: "#fff",
                      cursor: "pointer",
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "bold",
                      height: "40px",
                      padding: "0 24px",
                    }}
                  >
                    Continue with Facebook
                  </button>
                </>
              )}
            {(customer?.apiKey360Dialog || customer?.waAccessToken) && (
              <WhatsappQualityScoreBanner customer={customer}  className="mt-5 h-[12rem] w-full xl:w-1/2"/>
            )}
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
